"use client"

import React from "react"
import { useRouter, useSearchParams } from "next/navigation"
import { DEFAULT_SEARCH_RESULT_SORT_ORDER, SEARCH_PARAMS_SORT_ORDER } from "@/constants/ui"
import { useUbStorefrontState } from "@/store/ubStorefrontState"
import { ClassValue } from "clsx"
import { useTranslations } from "next-intl"

import { cn } from "@/lib/utils"
import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/components"
import { getPaginationSearchParams } from "@/components/search-and-category/pagination-info"

const SearchResultSortOrder = (props: { className?: ClassValue }) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const paginationSearchParams = getPaginationSearchParams(searchParams)
  const { setIsLoading } = useUbStorefrontState()

  const t = useTranslations("storefront")

  const handleChange = (value: string) => {
    setIsLoading(true)
    const newSearchParams = new URLSearchParams(searchParams)
    value === DEFAULT_SEARCH_RESULT_SORT_ORDER[0]
      ? newSearchParams.delete(SEARCH_PARAMS_SORT_ORDER)
      : newSearchParams.set(SEARCH_PARAMS_SORT_ORDER, value)
    router.push("?" + newSearchParams.toString())
  }

  return (
    <Select
      aria-label={t("sort_order.sort_order")}
      value={paginationSearchParams.sortOrder}
      onValueChange={(value: string) => handleChange(value)}
    >
      <SelectTrigger className={cn("border-none bg-transparent pr-0 pt-0 text-base", props.className)}>
        <p className={"mr-2 hidden @[12rem]:inline"}>{t("sort_order.sort_order")}</p>
        <span className="font-medium text-primary">{t("sort_order." + paginationSearchParams.sortOrder)}</span>
      </SelectTrigger>
      <SelectContent className="">
        {DEFAULT_SEARCH_RESULT_SORT_ORDER.map((key) => (
          <SelectItem className="cursor-pointer" value={key} key={key} aria-label={t("sort_order." + key)}>
            {t("sort_order." + key)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export default SearchResultSortOrder
